import {
  CreateButton,
  Datagrid,
  FunctionField,
  Record,
  sanitizeListRestProps,
  TextField,
  TopToolbar,
  useListContext,
} from "react-admin";
import fuelProviders from ".";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import { FuelProviderDto } from "../../../common/data/service-proxies";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import { Box, useTheme, Theme } from "@material-ui/core";

import "../../common/styles/list-style.css";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { DeleteRecordMenuItem } from "../../common/data-grid-fields/DeleteRecordMenuItem";

interface Props {}

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const { basePath } = useListContext();
  const permissions = useActionPermissions();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {permissions &&
        permissions[permissionNames.admin.fuelProviders.main] &&
        permissions[permissionNames.admin.fuelProviders.create] && (
          <CreateButton basePath={basePath} />
        )}
    </TopToolbar>
  );
};

export const FuelProvidersList = (props: Props) => {
  const permissions = useActionPermissions();
  const theme: Theme = useTheme();

  return (
    <div className="content-container">
      <DefaultProLogsList
        empty={<ProLogsEmpty iconType={fuelProviders.icon} />}
        className="content-list"
        title="resources.admin-fuel-providers.name"
        bulkActionButtons={false}
        actions={<ListActions />}
        {...props}
      >
        <Datagrid>
          <TextField
            source="provider"
            label="resources.admin-fuel-providers.labels.provider"
          />
          <TextField
            source="name"
            label="resources.admin-fuel-providers.labels.name"
          />
          <FunctionField<FuelProviderDto & Record>
            source="status"
            headerClassName="centered-content"
            label="resources.common.labels.active"
            render={(record) => (
              <Box className="centered-content">
                {record?.status === "Active" ? (
                  <CheckBoxIcon
                    className={record.status}
                    style={{
                      color: theme.palette.success.main,
                    }}
                  />
                ) : (
                  <IndeterminateCheckBoxIcon
                    className={record?.status}
                    style={{
                      color: theme.palette.error.main,
                    }}
                  />
                )}
              </Box>
            )}
          />
          <ActionsField
            editable={() =>
              permissions &&
              permissions[permissionNames.admin.fuelProviders.main] &&
              permissions[permissionNames.admin.fuelProviders.update]
            }
            canActivateOrDeactivate={() =>
              permissions &&
              permissions[permissionNames.admin.fuelProviders.main] &&
              permissions[permissionNames.admin.fuelProviders.update]
            }
          >
            {permissions &&
              permissions[permissionNames.admin.fuelProviders.main] &&
              permissions[permissionNames.admin.fuelProviders.delete] && (
                <DeleteRecordMenuItem />
              )}
          </ActionsField>
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
